import type { StudioItem, StudioModel } from './use-studio';
import type { CurrentWorkspace } from '@mio/shared';

/**
 * A valid last visit wins, including completed activities revisited for reference.
 * Older accounts without recorded visits retain the selected-workshop/curriculum fallback.
 */
export function continueAtFor(
  studio: Pick<StudioModel, 'continueAt' | 'sequence'>,
  workspace: Pick<CurrentWorkspace, 'activity'> | null | undefined,
  lastVisit?: { activityId: string; kind: StudioItem['kind'] } | null,
): StudioItem | null {
  const visited = studio.sequence.find(
    (item) => item.id === lastVisit?.activityId && item.kind === lastVisit.kind,
  );
  if (visited) return visited;
  const selected = workspace?.activity;
  if (selected?.accessible) {
    const item = studio.sequence.find((entry) => entry.id === selected.id);
    if (item && item.status !== 'complete') return item;
  }
  return studio.continueAt;
}
